<template lang="pug">
  path(:d="`M ${lw/2} ${lw/2} h${L*W-lw/2} v${W-L*W-lw/2} h${W-L*W-lw/2} v${L*W-lw/2} h-${W-lw} v-${W-lw}Z`" :stroke-width="lw" stroke-dasharray="400" :stroke-dashoffset="1200-progress*400-progress2*400")
  
</template>

<script>
import gsap from 'gsap'
export default {
  name: 'FramePathLoop',
  props: {
    //progress: { default: 0 },
  },
  data() {
    return {
      progress: 0,
      progress2: 0,
      lw: 4,
      L: 0.58,
      W: 100,
    }
  },
  mounted() {
    //console.log(this.$el.getTotalLength())
    this.anime(1)
  },
  methods: {
    anime(dur) {
      return gsap
        .timeline({ repeat: -1 })
        .to(this, { progress: 1, duration: dur })
        .to(this, { progress2: 1, duration: dur })
    },
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
path
  stroke-linecap: square
  stroke-linejoin: miter
  stroke: $cl-blue
</style>
